import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CFormLabel,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";

import moment from "moment";
import { Link } from "react-router-dom";
import ReactSelect from "react-select";
import GpsLocationModal from "src/components/GPSLocation/GpsLocationModal";
import { getCountryList } from "src/services/country.services";
import { getDeviceList } from "src/services/gps-location.services";
import DeviceHistoryDetailsModal from "./DeviceHistoryDetailsModal";

const ManageGpsLocationReport = () => {
  const today = new Date();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [fromDate, setFromDate] = useState(
    moment(today).subtract(2, "hours").toDate()
  );
  const [toDate, setToDate] = useState(moment(today).toDate());
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedDeviceId, setSelectedDeviceId] = useState(null);
  const [openDeviceId, setOpenDeviceId] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));
  const [countries, setCountries] = useState([]);
  const [deviceList, setDeviceList] = useState([]);

  const handleDateChange = (date, identity) => {
    if (!date) return;

    if (identity == "from") {
      setFromDate(date);
      setToDate(moment(date).toDate());
    }
    if (identity == "to") {
      setToDate(date);
    }
  };

  const getCountries = async () => {
    getCountryList({ limit: 99, page: 1 }).then((response) => {
      setCountries(response.data);
    });
  };

  const getDevices = async (country_id, device_id) => {
    setIsLoading(true);
    try {
      const res = await getDeviceList(country_id, device_id);
      setDeviceList(res?.devices);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (countries?.length > 1) {
      return;
    }
    if (user?.userType === "superAdmin") {
      getCountries();
    }
  }, [user]);

  const handleSubmitFilter = () => {
    getDevices(selectedCountry?._id, selectedDeviceId?.id);
  };

  const handleReset = () => {
    setSelectedCountry(null);
    setSelectedDeviceId(null);
    handleDateChange(null, "from");
    setIsLoading(true);
    setDeviceList([]);
    getDevices();
  };

  useEffect(() => {
    getDevices();
  }, []);

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            {user?.userType === "superAdmin" ? (
              <CCol sm={12} md={4} lg={user?.userType === "superAdmin" ? 3 : 4}>
                <CFormLabel htmlFor="bookingOrderId">Country</CFormLabel>
                <ReactSelect
                  value={selectedCountry}
                  options={countries}
                  placeholder="Select Country"
                  getOptionLabel={(e) => e.name} // Map the custom label field
                  getOptionValue={(e) => e._id} // Map the custom value field
                  onChange={(e) => {
                    setSelectedCountry(e);
                    setSelectedDeviceId(null);
                  }}
                />
              </CCol>
            ) : (
              ""
            )}
            <CCol sm={12} md={4} lg={user?.userType === "superAdmin" ? 3 : 4}>
              <CFormLabel>Vehicle</CFormLabel>
              <ReactSelect
                value={selectedDeviceId}
                options={deviceList}
                placeholder="Select Vehicle"
                getOptionLabel={(e) => e.plateNumber} // Map the custom label field
                getOptionValue={(e) => e.id} // Map the custom value field
                onChange={(e) => setSelectedDeviceId(e)}
                disabled={!selectedCountry || !selectedCountry?._id}
              />
            </CCol>
            <CCol sm={12} md={3}>
              <CFormLabel htmlFor="bookingOrderId">
                {" "}
                Start Date Time:
              </CFormLabel>
              <ReactDatePicker
                showIcon={true}
                dateFormat="dd/MM/yyyy hh:mm a"
                className="form-control"
                onChange={(date) => handleDateChange(date, "from")}
                selected={fromDate}
                showTimeSelect
                selectsStart
                startDate={fromDate}
                // endDate={toDate}
              />
            </CCol>
            <CCol sm={12} md={3}>
              <CFormLabel htmlFor="bookingOrderId"> End Date Time:</CFormLabel>
              {fromDate && (<ReactDatePicker
                showIcon={true}
                dateFormat="dd/MM/yyyy hh:mm a"
                className="form-control"
                onChange={(date) => handleDateChange(date, "to")}
                selected={toDate}
                showTimeSelect
                disabled={!fromDate}
                selectsEnd
                startDate={fromDate}
                endDate={toDate}
                minDate={moment(fromDate).toDate()}
                minTime={moment(fromDate).toDate()}
                maxDate={moment(fromDate).toDate()}
                maxTime={moment(fromDate).endOf('day').toDate()}
              />)}
            </CCol>
          </CRow>
          <div className="d-flex justify-content-end mt-3">
            <CButton
              type="submit"
              color="primary"
              className="px-5 py-2 me-3"
              onClick={handleSubmitFilter}
            >
              Submit
            </CButton>
            <CButton
              type="submit"
              className="px-5 py-2 ms-3 btn-oliveGreen"
              onClick={handleReset}
            >
              Reset
            </CButton>
          </div>
        </CCardBody>
      </CCard>
      <CCard className="mb-4">
        <CCardBody>
          <CRow className="justify-content-between">
            <CCol sm={5}>
              <h4 id="traffic" className="card-title mb-0">
                Vehicle Tracking History
              </h4>
              {/* <div className="small text-medium-emphasis">January - July 2021</div> */}
            </CCol>
            <CCol sm={3} className=" d-md-block  text-end">
              <CButton className="btn btn-primary">
                <Link
                  to={"/gps-location"}
                  className="text-decoration-none text-white"
                >
                  Live Tracking
                </Link>
              </CButton>
            </CCol>
          </CRow>
          <br />
          <CTable align="middle" className="mb-0 border" hover responsive>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell className="text-center">
                  S.No
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Plate Number
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  VehicleName
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Country
                </CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading && (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="4">Loading...</CTableDataCell>
                </CTableRow>
              )}
              {!isLoading &&
                deviceList.length > 0 &&
                deviceList?.map((item, idx) => (
                  <CTableRow
                    className="text-center"
                    key={idx}
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenDeviceId(item?.id);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <CTableDataCell className="text-center">
                      {idx + 1}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item?.plateNumber}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item?.vehicleName}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item?.country?.name}
                    </CTableDataCell>
                  </CTableRow>
                ))}
              {!isLoading && deviceList.length <= 0 && (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="4">
                    There is no data!!
                  </CTableDataCell>
                </CTableRow>
              )}
            </CTableBody>
          </CTable>
        </CCardBody>
      </CCard>

      {selectedDevice && (
        <GpsLocationModal
          {...{ selectedDevice, setSelectedDevice }}
          lat={selectedDevice.history?.latitude}
          long={selectedDevice.history?.longitude}
        />
      )}

      {openDeviceId && (
        <DeviceHistoryDetailsModal
          deviceId={openDeviceId}
          close={setOpenDeviceId}
          ts1={fromDate.valueOf()}
          ts2={toDate.valueOf()}
        />
      )}
    </>
  );
};

export default ManageGpsLocationReport;
